<template>
  <div>
    <div
      class="d-flex align-items-center p-2">
      <span
        class="notifications-heading-mark mr-1" />

      <h3 class="notifications__heading">
        {{ evaluationMonth }}月 月間目標
      </h3>
    </div>
    <div
      @click="onClickActivePart">
      <div class="comment p-2">
        <div
          class="comment__item">
          <div class="comment__head d-flex align-items-center justify-content-between mb-2">
            <div class="comment__content d-flex align-items-center">
              <User :user="mandalaGoalSelfEvaluationComment.createdBy">
                <p class="comment__date">
                  {{ mandalaGoalSelfEvaluationComment.createdAt | prettyDateTime }}
                </p>
              </User>
            </div>
          </div>
          <div class="comment__body">
            <p>{{ mandalaGoalSelfEvaluationComment.detail | emptyChar("[添付ファイルのみ]") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/components/parts/User.vue'
import { format } from 'date-fns'
export default {
  components: {
    User,
  },
  props: {
    notification: {
      type: Object,
      required: true
    },
  },
  computed: {
    mandalaGoalSelfEvaluationComment() {
      return this.notification.mandalaGoalSelfEvaluationComment
    },
    mandalaGoalSelfEvaluation() {
      return this.mandalaGoalSelfEvaluationComment.mandalaGoalSelfEvaluation
    },
    evaluationMonth() {
      return format(new Date(this.mandalaGoalSelfEvaluation.yearMonth), 'M')
    }
  },
  methods: {
    onClickActivePart() {
      this.$emit('click-notification')
    },
  }
}
</script>

<style lang="scss" scoped>
.notifications-heading-mark {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: $grey16;
  &--marked {
    background: $pink;
  }
}

.notifications{
  &__heading{
    font-size: $fs-nm;
    font-weight: bold;
    position: relative;
  }
}

.comment{
  &__item {
    background-color: $grey15;
    padding: 8px;
  }
  &__img{
    width: 30px;
    height: 30px;
    object-fit: cover;
  }
  &__name{
    font-weight: bold;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
  &__body{
    white-space:pre-wrap;
    word-wrap:break-word;
    color: $grey04;
  }
}

</style>